import React from 'react';
import { node, object } from 'prop-types';
import { AppProvider } from '../AppContext';

const Store = ({ seller, gig, assetsSharing, children }) => (
    <AppProvider seller={seller} gig={gig} assetsSharing={assetsSharing}>
        {children}
    </AppProvider>
);

Store.propTypes = {
    seller: object,
    gig: object,
    assetsSharing: object,
    children: node,
};

export default Store;
